import { Component } from "react";

export class SafeBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error, info) { console.error("UI error:", error, info?.componentStack); }
  render() {
    if (!this.state.failed) return this.props.children;
    return this.props.fallback ?? (
      <div className="grid min-h-[100dvh] place-items-center bg-[#f4f6f5] p-6 text-center" data-testid="app-error-screen">
        <div>
          <p className="font-display text-xl font-bold text-slate-900">Dr. Nova</p>
          <p className="mt-2 text-sm text-slate-600">Si è verificato un problema. / Something went wrong.</p>
          <button data-testid="app-error-reload-btn" onClick={() => window.location.reload()} className="btn-primary mt-4 !py-2.5">Ricarica / Reload</button>
        </div>
      </div>
    );
  }
}
